var _defs, _g, _path, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191,
    height: 152,
    viewBox: "0 0 191 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "20fvistwka",
    d: "M0 0.141L127.954 0.141 127.954 58.719 0 58.719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8fvst5viac",
    d: "M0.657 0.005L128.61 0.005 128.61 58.582 0.657 58.582z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "kzrnngs08e",
    width: "125%",
    height: "700%",
    x: "-12.5%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.24
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 70.488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qayu16namb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#20fvistwka"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    fillRule: "nonzero",
    d: "M120.74.14c3.984 0 7.214 3.23 7.214 7.214v33.247c0 3.984-3.23 7.214-7.214 7.214H96.51v8.544c0 1.876-2.086 3-3.652 1.967L76.903 47.815H7.213C3.23 47.815 0 44.585 0 40.601V7.354C0 3.371 3.23.141 7.213.141H120.74V.14z",
    mask: "url(#qayu16namb)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    fillRule: "nonzero",
    d: "M69.778 105.878c1.336 0 2.419-1.841 2.419-4.11v-.084c0-2.269-1.083-4.11-2.419-4.11H14.116c-1.337 0-2.42 1.841-2.42 4.11v.084c0 2.269 1.084 4.11 2.42 4.11h55.662zM44.299 91.422c1.53 0 2.77-1.782 2.77-3.98v-.344c0-2.198-1.24-3.98-2.77-3.98H14.466c-1.53 0-2.77 1.782-2.77 3.98v.345c0 2.197 1.24 3.98 2.77 3.98h29.833v-.001zm67.524 0c1.53 0 2.769-1.782 2.769-3.98v-.344c0-2.198-1.24-3.98-2.77-3.98H55.57c-1.53 0-2.77 1.782-2.77 3.98v.345c0 2.197 1.24 3.98 2.77 3.98h56.254l-.001-.001z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.04 .308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7uk0rb0cld",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8fvst5viac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    fillRule: "nonzero",
    d: "M7.87.005C3.888.005.657 3.233.657 7.217v33.248c0 3.984 3.231 7.213 7.213 7.213h24.232v8.544c0 1.877 2.085 3 3.65 1.968L51.71 47.678h69.688c3.985 0 7.214-3.229 7.214-7.213V7.217c0-3.984-3.229-7.212-7.214-7.212H7.87z",
    mask: "url(#7uk0rb0cld)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2F2A3",
    fillRule: "nonzero",
    d: "M174.843 20.765H80.236c-2.27 0-4.11-1.842-4.11-4.11v-.083c0-2.27 1.84-4.112 4.11-4.112h94.607c2.27 0 4.11 1.842 4.11 4.112v.082c0 2.27-1.84 4.11-4.11 4.11m-15.899 14.457c-2.198 0-3.98-1.782-3.98-3.98v-.344c0-2.198 1.782-3.981 3.98-3.981h16.03c2.198 0 3.98 1.783 3.98 3.981v.345c0 2.197-1.782 3.98-3.98 3.98h-16.03v-.001zm-46.641 0c-2.198 0-3.98-1.782-3.98-3.98v-.344c0-2.198 1.782-3.981 3.98-3.981h33.107c2.198 0 3.98 1.783 3.98 3.981v.345c0 2.197-1.782 3.98-3.98 3.98h-33.107v-.001z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#345749",
    transform: "translate(53 138)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.539,
    style: {
      mixBlendMode: "soft-light"
    },
    cx: 46.44,
    cy: 3.24,
    rx: 46.44,
    ry: 3.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.269,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 46.44,
    cy: 4.32,
    filter: "url(#kzrnngs08e)",
    rx: 38.88,
    ry: 1.62
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGroups);
export default __webpack_public_path__ + "static/media/emptyGroups.a451baf122e28b9ff17a9044fb54e034.svg";
export { ForwardRef as ReactComponent };